/**
 * Fix modulo operator when operand is negative.
 * Should behave like Python % operator.
 */
export default function(n, m) {
  return n < 0 ? ((n % m) + m) % m : n % m
}
